import { BaseAutomationProvider } from '../browser/IAutomationProvider'

/** Stub provider used until real portal automation exists. */
export class StubAutomationProvider extends BaseAutomationProvider {
  readonly supplierCode: string

  constructor(supplierCode: string) {
    super()
    this.supplierCode = supplierCode
  }
}
